// extracted by mini-css-extract-plugin
module.exports = {"DownloadsList":"DownloadsList_DownloadsList__2Ndos","Title":"DownloadsList_Title__3UHfB"};